/* Hey Lovely · Shipping Protection option (assets/hl-ship-protect.js)
   Markup and styles: snippets/hl-ship-protect.liquid.
   - Puts the option above the Checkout button in the cart drawer and on the cart page,
     and puts it back whenever the theme re-renders the cart.
   - Tick = add the protection product (qty 1). Untick = remove it. Uses the theme's own
     Shopify.actions.updateCart so the cart, total and drawer update straight away.
   - Keeps it tidy: never more than 1, removed if it is the only thing left in the cart,
     and the cart count bubbles don't count it. */
(() => {
  if (window.__hlSP) return;
  const cfg = window.HL_SP;
  const tpl = document.getElementById('hl-sp-tpl');
  if (!cfg || !cfg.variantId || !tpl) return;
  window.__hlSP = true;

  const VID = Number(cfg.variantId);
  const state = { qty: 0, others: 0, key: null, known: false };
  let busy = false;
  let uid = 0;

  const all = () => document.querySelectorAll('[data-hl-sp]');

  function render() {
    all().forEach((box) => {
      const input = box.querySelector('.hl-sp__input');
      if (!input) return;
      input.checked = state.qty > 0;
      input.disabled = busy;
      box.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
  }

  function insert() {
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      const prev = ctas.previousElementSibling;
      if (prev && prev.hasAttribute('data-hl-sp')) return;
      const node = tpl.content.firstElementChild.cloneNode(true);
      const id = 'hl-sp-input-' + (++uid);
      node.querySelector('.hl-sp__input').id = id;
      node.querySelector('.hl-sp__main').htmlFor = id;
      ctas.parentNode.insertBefore(node, ctas);
    });
    render();
  }

  function fixCounts() {
    if (!state.known || state.qty === 0) return;
    const total = String(state.others + state.qty);
    document.querySelectorAll('.cart-bubble__text-count, .theme-drawer__badge').forEach((el) => {
      if (el.textContent.trim() === total) el.textContent = String(state.others);
    });
  }

  async function readCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const cart = await res.json();
    const lines = cart.items.filter((i) => Number(i.variant_id) === VID);
    state.qty = lines.reduce((n, i) => n + i.quantity, 0);
    state.key = lines.length ? lines[0].key : null;
    state.others = cart.item_count - state.qty;
    state.known = true;
    return cart;
  }

  async function update(lines) {
    const actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      const result = await actions.updateCart({ lines }, { event: { context: 'cart' } });
      if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
      return true;
    }
    const l = lines[0];
    const res = l.id
      ? await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: l.id, quantity: l.quantity }) })
      : await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: VID, quantity: l.quantity }] }) });
    if (!res.ok) throw new Error(String(res.status));
    window.location.reload();
    return false;
  }

  async function tidy() {
    if (busy) return;
    try {
      await readCart();
      if (state.qty > 0 && state.others === 0) {
        busy = true;
        await update([{ id: state.key, quantity: 0 }]);
        await readCart();
      } else if (state.qty > 1) {
        busy = true;
        await update([{ id: state.key, quantity: 1 }]);
        await readCart();
      }
    } catch (e) {
      /* leave the cart as it is */
    } finally {
      busy = false;
      render();
      fixCounts();
    }
  }

  async function setProtection(on) {
    if (busy) return;
    busy = true;
    render();
    try {
      await readCart();
      if (on && state.qty === 0) {
        await update([{ merchandiseId: String(VID), quantity: 1 }]);
      } else if (!on && state.qty > 0) {
        await update([{ id: state.key, quantity: 0 }]);
      }
      await readCart();
    } catch (e) {
      try { await readCart(); } catch (e2) {}
    } finally {
      busy = false;
      render();
      fixCounts();
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('hl-sp__input')) return;
    setProtection(input.checked);
  });

  let timer = null;
  const onCartChange = () => {
    clearTimeout(timer);
    timer = setTimeout(tidy, 250);
  };
  ['cart:update', 'shopify:cart:lines-update'].forEach((name) => document.addEventListener(name, onCartChange, true));

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      insert();
      fixCounts();
    });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  const start = () => { insert(); tidy(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
